<p class="logo-container"><img src="assets/svg/elogbooks-logo.svg" width="32px" height="32px" alt="logo" /> Elogbooks integration</p>

<div class="tabview-list">
  <div class="active"><i class="mdi mdi-new"></i> Create Reactive Job</div>
  <div>&nbsp;</div>
</div>

<div class="mt-1">
  <div>
    <div class="form-group">
      <label for="title">Site</label>
      @if (rule.integration.states[state].siteId) {
        <p>{{ rule.integration.states[state].siteId }} - {{ rule.integration.states[state].siteTitle }}</p>
      }
      @if (!rule.integration.states[state].siteId) {
        <p>No site selected.</p>
      }
    </div>
  </div>
  <div>
    <div class="form-group">
      <label for="title"></label>
      <div>
        <app-button label="Choose site" (click)="getSites()" />
      </div>
    </div>
  </div>

  <div>
    <div class="form-group">
      <label for="title">Priority</label>
      @if (rule.integration.states[state].priorityId) {
        <p>{{ rule.integration.states[state].priorityId }} - {{ rule.integration.states[state].priorityTitle }}</p>
      }
      @if (!rule.integration.states[state].priorityId) {
        <p>No priority selected.</p>
      }
    </div>
  </div>
  <div>
    <div class="form-group">
      <label for="title"></label>
      <div>
        <app-button [disabled]="!rule.integration.states[state].siteId" label="Choose priority" (click)="getPriorities()" />
      </div>
    </div>
  </div>

  <div>
    <div class="form-group">
      <label for="summary">Job summary</label>
      <input maxlength="50" id="summary" name="summary" class="fourd" type="text" [(ngModel)]="rule.integration.states[state].summary" />
    </div>
  </div>
  <div>
    <div class="form-group">
      <label for="description">Job description</label>
      <textarea id="description" name="description" class="fourd" type="text" [(ngModel)]="rule.integration.states[state].description" rows="3"></textarea>
    </div>
  </div>
</div>

@if (isSelecting?.action) {
  <app-elogbooks-popup [target]="isSelecting.action" [id]="isSelecting.id" (onDismiss)="selected($event)"> </app-elogbooks-popup>
}
